import { GlobalState } from "little-state-machine";
import { ApplicationType } from "interfaces/models/ApplicationType";

export const updateApplicationTypesFiltered = (state: GlobalState, applicationTypesFiltered: ApplicationType[]) => ({
  ...state,
  applicationTypesFiltered
});
